export const OVERVIEW_TITLE = "Overview";
export const OVERVIEW_SUBTITLE =
  "View your personal account preferences and settings";

export const OVERVIEW_ORGANISATION_TITLE = "ORGANISATION";

export const OVERVIEW_LOADING_MESSAGE = "Loading your settings…";

export const OVERVIEW_PROFILE_SECTION_TITLE = "Profile information";
export const OVERVIEW_PROFILE_FIRST_NAME_LABEL = "FIRST NAME";
export const OVERVIEW_PROFILE_LAST_NAME_LABEL = "LAST NAME";
export const OVERVIEW_PROFILE_CITY_LABEL = "CITY";
export const OVERVIEW_PROFILE_COUNTRY_LABEL = "COUNTRY";
export const OVERVIEW_PROFILE_OCCUPATION_LABEL = "OCCUPATION";
export const OVERVIEW_PROFILE_INDUSTRY_LABEL = "INDUSTRY";
export const OVERVIEW_PROFILE_JOB_TITLE_LABEL = "JOB TITLE";

export const OVERVIEW_SECURITY_SECTION_TITLE = "Security";
export const OVERVIEW_SECURITY_EMAIL_LABEL = "EMAIL ADDRESS";

export const OVERVIEW_SECURITY_INFO_PREFIX =
  "To change your email address or close your account please contact ";

export const OVERVIEW_FOOTER_SUPPORTING_COPY_PREFIX =
  "To make changes to your access or settings, please contact your organisation's admin or ";

export const OVERVIEW_MISSING_VALUE_PLACEHOLDER = "Not provided";

export const OVERVIEW_ERROR_TITLE = "We couldn't load your settings";
export const OVERVIEW_ERROR_DESCRIPTION_LINE_1 =
  "Something went wrong while loading your settings.";
export const OVERVIEW_ERROR_DESCRIPTION_LINE_2 = "Please try again.";
export const OVERVIEW_ERROR_RETRY_LABEL = "Retry";
export const OVERVIEW_ERROR_SUPPORT_PREFIX =
  "If the problem persists, contact ";
